module.exports = __webpack_public_path__ + "static/media/stopwatch.ec6979bc.svg";